<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title d-flex align-items-center">
        <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
          <inline-svg src="media/icons/duotune/abstract/abs007.svg" />
        </span>
        <h3 class="fw-bold m-0 text-gray-800">Usuários Conectados</h3>
      </div>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharSessaoUsuario', false)"
      >
        <span class="svg-icon svg-icon-1 svg-icon lh-0">
          <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              type="text"
              id="txtPesquisarSessaoUsuarios"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid w-300px ps-15"
              placeholder="Pesquisar Usuários Conectados"
            />
          </div>
        </div>
        <div class="card-toolbar">
          <button
            v-if="checkedSessaoUsuarioConnections.length === 0"
            class="btn btn-sm btn-light-info"
            @click="atualizarSessoes()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr029.svg" />
            </span>
            Atualizar
          </button>
          <div
            v-else
            class="d-flex justify-content-end align-items-center"
            data-kt-customer-table-toolbar="selected"
          >
            <div class="fw-bolder me-5">
              <span class="me-2">{{
                checkedSessaoUsuarioConnections.length
              }}</span
              >Selecionado(s)
            </div>
            <button
              v-if="this.desconectar"
              type="button"
              class="btn btn-sm btn-danger"
              @click="desconectarSelecionados()"
            >
              Desconectar Selecionado(s)
            </button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhum usuário conectado foi encontrado"
          @checked-rows="checkedSessaoUsuarioConnections = $event"
          :showFilters="false"
        >
          <template v-slot:cell-checkbox="{ row: sessaoUsuarioConnection }">
            <div
              class="form-check form-check-sm form-check-custom form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="sessaoUsuarioConnection.connection_id"
                v-model="checkedSessaoUsuarioConnections"
              />
            </div>
          </template>
          <template v-slot:cell-id="{ row: sessaoUsuarioConnection }">
            {{ sessaoUsuarioConnection.id }}
          </template>
          <template
            v-slot:cell-connection_id="{ row: sessaoUsuarioConnection }"
          >
            {{ sessaoUsuarioConnection.connection_id }}
          </template>
          <template v-slot:cell-UsuarioNome="{ row: sessaoUsuarioConnection }">
            {{
              sessaoUsuarioConnection.Usuario &&
              sessaoUsuarioConnection.Usuario.nome
                ? sessaoUsuarioConnection.Usuario.nome
                : ""
            }}
          </template>
          <template
            v-slot:cell-SessaoUsuarioSessionId="{
              row: sessaoUsuarioConnection,
            }"
          >
            {{
              sessaoUsuarioConnection.SessaoUsuario &&
              sessaoUsuarioConnection.SessaoUsuario.session_id
                ? sessaoUsuarioConnection.SessaoUsuario.session_id
                : ""
            }}
          </template>
          <template
            v-slot:cell-SessaoUsuarioTipoDispositivo="{
              row: sessaoUsuarioConnection,
            }"
          >
            {{
              sessaoUsuarioConnection.SessaoUsuario &&
              sessaoUsuarioConnection.SessaoUsuario.tipo_dispositivo
                ? sessaoUsuarioConnection.SessaoUsuario.tipo_dispositivo
                : ""
            }}
          </template>
          <template
            v-slot:cell-SessaoUsuarioSistemaOperacional="{
              row: sessaoUsuarioConnection,
            }"
          >
            {{
              sessaoUsuarioConnection.SessaoUsuario &&
              sessaoUsuarioConnection.SessaoUsuario.sistema_operacional
                ? sessaoUsuarioConnection.SessaoUsuario.sistema_operacional
                : ""
            }}
          </template>
          <template
            v-slot:cell-SessaoUsuarioNavegador="{
              row: sessaoUsuarioConnection,
            }"
          >
            {{
              sessaoUsuarioConnection.SessaoUsuario &&
              sessaoUsuarioConnection.SessaoUsuario.navegador
                ? sessaoUsuarioConnection.SessaoUsuario.navegador
                : ""
            }}
          </template>
          <template v-slot:cell-createdAt="{ row: sessaoUsuarioConnection }">
            {{
              this.$utils.formatarDataHoraFusoHorario(
                sessaoUsuarioConnection.createdAt
              )
            }}
          </template>
          <template v-slot:cell-acoes="{ row: sessaoUsuarioConnection }">
            <div>
              <button
                v-if="this.desconectar"
                class="btn btn-sm btn-light-danger me-2"
                @click="
                  desconectarRegistro(sessaoUsuarioConnection.connection_id)
                "
              >
                Desconectar
              </button>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
import hubConnection from "@/utils/signalrHub";

export default {
  emits: ["fecharSessaoUsuario"],
  components: {
    Datatable,
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
    usuario: { type: Object, required: false, default: null },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    atualizarSessoes() {
      this.$refs.table.setLoading(true);
      this.tableData.defaultFilter =
        "Usuario/id_empresa eq " +
        (this.user && this.user.User
          ? this.user.User.id_empresa
          : this.usuario.id_empresa);
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(connection_id, '" +
          pesquisa +
          "') or contains(Usuario/nome, '" +
          pesquisa +
          "') or contains(SessaoUsuario/session_id, '" +
          pesquisa +
          "') or contains(SessaoUsuario/tipo_dispositivo, '" +
          pesquisa +
          "') or contains(SessaoUsuario/sistema_operacional, '" +
          pesquisa +
          "') or contains(SessaoUsuario/navegador, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async desconectarSelecionados() {
      await this.$swal.showQuestionAlert(
        "Deseja desconectar os usuários selecionados?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.desconectouUsuario = true;
            this.$refs.table.setLoading(true);
            for (
              var i = 0;
              i < this.checkedSessaoUsuarioConnections.length;
              i++
            ) {
              await this.desconectarSessaoUsuario(
                this.checkedSessaoUsuarioConnections[i]
              );
            }
            if (this.desconectouUsuario === true) {
              toast.success("Usuários desconectados com sucesso!", {
                timeout: 3000,
              });
            }
            this.atualizarSessoes();
          }
        }
      );
    },
    async desconectarRegistro(connection_id) {
      await this.$swal.showQuestionAlert(
        "Deseja desconectar o usuário?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.desconectouUsuario = true;
            this.$refs.table.setLoading(true);
            await this.desconectarSessaoUsuario(connection_id);
            if (this.desconectouUsuario === true) {
              toast.success("Usuário desconectado com sucesso!", {
                timeout: 3000,
              });
            }
            this.atualizarSessoes();
          }
        }
      );
    },
    async desconectarSessaoUsuario(connection_id) {
      await hubConnection.connection.invoke(
        "DesconectarConnection",
        connection_id
      );
    },
    async verificarRestricoes() {
      if (this.user && this.user.User) {
        if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
          this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find(
            (element) => {
              if (element.regra === "Permitir.SessaoUsuario.Desconectar") {
                this.desconectar = true;
              }
            }
          );
        }
      } else if (this.usuario != null) {
        if (
          this.usuario.EmitenteTipoUsuario.EmitenteRestricao.find(
            (modulo) => modulo.regra == "Permitir.SessaoUsuario.Desconectar"
          )
        ) {
          this.desconectar = true;
        }
      }
    },
    formatDataHora(data, utc) {
      const date = utc ? this.$utils.removerFusoHorario(data) : new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${this.$utils.getTimeZoneServidor()}`;
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.tableData.defaultFilter =
      "Usuario/id_empresa eq " +
      (this.user && this.user.User
        ? this.user.User.id_empresa
        : this.usuario.id_empresa);
    this.$utils.requestFocus("txtPesquisarSessaoUsuarios");
  },
  data() {
    return {
      desconectar: false,
      checkedSessaoUsuarioConnections: [],
      errosValidacaoGeral: [],
      desconectouUsuario: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "ID Conexão",
          key: "connection_id",
          sortable: true,
        },
        {
          name: "Usuário",
          key: "UsuarioNome",
          sortingField: "Usuario/nome",
          sortable: true,
        },
        {
          name: "Sessão",
          key: "SessaoUsuarioSessionId",
          sortingField: "SessaoUsuario/session_id",
          sortable: true,
        },
        {
          name: "Dispositivo",
          key: "SessaoUsuarioTipoDispositivo",
          sortingField: "SessaoUsuario/tipo_dispositivo",
          sortable: true,
        },
        {
          name: "Sistema",
          key: "SessaoUsuarioSistemaOperacional",
          sortingField: "SessaoUsuario/sistema_operacional",
          sortable: true,
        },
        {
          name: "Navegador",
          key: "SessaoUsuarioNavegador",
          sortingField: "SessaoUsuario/navegador",
          sortable: true,
        },
        {
          name: "Início da Sessão",
          key: "createdAt",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "sessaoUsuarioConnection/getSessaoUsuarioConnectionOData",
        selectOData:
          "?$select=id,connection_id,createdAt&$expand=Usuario($select=nome),SessaoUsuario($select=session_id,tipo_dispositivo,sistema_operacional,navegador)",
        filterOData: "",
        search: "",
        defaultFilter: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
